'use client'

import { useState, useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Typography from '@mui/material/Typography'
import NextLink from 'next/link'
import { useMenu } from '@/common/_hooks/MenuContext'

interface BreadCrumbType {
  subtitle?: string
  items?: any[]
  title?: string
  children?: JSX.Element
}

interface BreadCrumbItem {
  to: string
  title: string
}

const Breadcrumb = ({ subtitle, items, title, children }: BreadCrumbType) => {
  const { matchedMenu } = useMenu()
  const [bCrumb, setBCrumb] = useState<BreadCrumbItem[]>([])

  useEffect(() => {
    if (!matchedMenu) return

    const list = matchedMenu.menuTypeCdPaths?.filter(
      (menuTypeCd) => menuTypeCd === 'MUT001',
    )
    const listLength = list?.length ?? 0

    // 새로운 breadcrumb 배열을 생성
    const initBCrumb = [
      {
        to: '/',
        title: 'Home',
      },
    ]

    matchedMenu.menuTypeCdPaths?.forEach((element, index) => {
      if (element === 'MUT001') {
        initBCrumb.push({
          to:
            index + 1 === listLength
              ? (matchedMenu.urlAddrPaths?.[index] ?? '#')
              : '#',
          title: matchedMenu.menuNmPaths?.[index] ?? '',
        })
      }
    })
    setBCrumb(initBCrumb)
  }, [matchedMenu])

  return (
    <Breadcrumbs
      separator={<div className="category-item-icon" />}
      sx={{ alignItems: 'center', mt: bCrumb ? '10px' : '' }}
      aria-label="breadcrumb"
      className="category-wrapper"
    >
      {bCrumb
        ? bCrumb.map((item, index) => (
            <div key={`${item.title}-${index}`}>
              {item.to ? (
                <NextLink href={item.to} passHref>
                  <Typography color="textSecondary">{item.title}</Typography>
                </NextLink>
              ) : (
                <Typography color="textPrimary">{item.title}</Typography>
              )}
            </div>
          ))
        : ''}
    </Breadcrumbs>
  )
}

export default Breadcrumb
